import React from 'react';

/**
 * HeyIntake Logo - Concentric rings + Okliko sparkle (large)
 * Sparkle scaled 25x to match Okliko reference proportions
 */
export function Logo({ size = 40, className = "" }) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 1200 1200" 
      width={size} 
      height={size}
      className={className}
    >
      {/* Circles centered at (480, 620) */}
      <circle cx="480" cy="620" r="350" fill="none" stroke="currentColor" strokeWidth="80"/>
      <circle cx="480" cy="620" r="230" fill="none" stroke="currentColor" strokeWidth="60"/>
      <circle cx="480" cy="620" r="120" fill="none" stroke="currentColor" strokeWidth="50"/>
      <circle cx="480" cy="620" r="60" fill="currentColor"/>
      
      {/* Okliko Sparkle - scaled 25x */}
      <g transform="translate(908, 248) scale(25)">
        <path 
          d="M4.21,-0.09c-.4-.5-.71-1.08-.93-1.76-.22-.68-.33-1.42-.33-2.21,0,.8-.11,1.53-.33,2.21-.22.68-.53,1.27-.92,1.76s-.87.88-1.43,1.16-1.17.42-1.85.42c.68,0,1.29.14,1.85.42.56.28,1.03.67,1.43,1.16s.7,1.08.92,1.76c.22.68.33,1.42.33,2.21,0-.8.11-1.53.33-2.21.22-.68.53-1.27.93-1.76s.88-.88,1.44-1.16c.56-.28,1.18-.42,1.85-.42-.68,0-1.3-.14-1.85-.42s-1.04-.66-1.44-1.16Z" 
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default Logo;
